import { api } from './client';
import {
  Employee,
  TeamAnalysis,
  TeamCommentUpdateData,
  TeamEvaluationResponse,
  EvaluationCreateData,
} from './types';

export const teamsApi = {
  getTeams: async (): Promise<{
    teams: string[];
    teams_with_codes: Array<{ name: string; code: string; org_unit_id: number; unit_type?: string; parent_code?: string | null; member_count: number }>;
    org_hierarchy: Array<{ name: string; code: string; org_unit_id: number; unit_type: string; parent_code: string | null; member_count: number }>;
  }> => {
    const response = await api.get('/api/teams');
    return response.data;
  },

  getTeamEmployees: async (teamName: string): Promise<{ team: string; employees: Employee[]; total: number }> => {
    const response = await api.get(`/api/teams/${encodeURIComponent(teamName)}/employees`);
    return response.data;
  },

  getTeamAnalysis: async (teamName: string, refresh: boolean = false): Promise<TeamAnalysis> => {
    const response = await api.get(`/api/teams/${encodeURIComponent(teamName)}/analysis`, {
      params: refresh ? { refresh: true } : {}
    });
    return response.data;
  },

  updateTeamComment: async (teamName: string, data: TeamCommentUpdateData): Promise<{ message: string; team: string; admin_comment: string; analysis?: any; reanalyzed: boolean }> => {
    const response = await api.put(`/api/teams/${encodeURIComponent(teamName)}/comment`, data);
    return response.data;
  },

  getTeamFolders: async (): Promise<{ teams: string[] }> => {
    const response = await api.get('/api/teams/folders');
    return response.data;
  },

  // === 팀 평가 히스토리 ===
  getTeamEvaluations: async (teamName: string): Promise<TeamEvaluationResponse> => {
    const response = await api.get(`/api/teams/${encodeURIComponent(teamName)}/evaluations`);
    return response.data;
  },

  addTeamEvaluation: async (teamName: string, data: EvaluationCreateData): Promise<{ message: string; evaluation_id: number; reanalyzed: boolean; analysis?: any }> => {
    const response = await api.post(`/api/teams/${encodeURIComponent(teamName)}/evaluations`, data);
    return response.data;
  },

  deleteTeamEvaluation: async (teamName: string, evalId: number): Promise<{ message: string; deleted_id: number }> => {
    const response = await api.delete(`/api/teams/${encodeURIComponent(teamName)}/evaluations/${evalId}`);
    return response.data;
  },

  getTeamTraining: async (teamName?: string): Promise<any> => {
    const response = await api.get('/api/training/teams', { params: teamName ? { team_name: teamName } : {} });
    return response.data;
  },
};
